import { stringify } from 'querystring'

const stringifyQueryString = (obj: Parameters<typeof stringify>[0]) =>
  stringify(obj).replace('%20', '+')

export default stringifyQueryString
